@if (user$ | async; as user) {
  <eui-app>
    <eui-app-header>
      <eui-header>
        <eui-header-logo></eui-header-logo>
        <eui-header-app appName="SME Week"></eui-header-app>
        <eui-language-selector></eui-language-selector>
        <eui-header-user-profile>
          <eui-user-profile-menu>
            <eui-user-profile-menu-item (click)="signOut()">
              <eui-icon-svg icon="sign-out:regular" aria-hidden="true"></eui-icon-svg>
              {{ 'SIGN_OUT' | translate }}
            </eui-user-profile-menu-item>
          </eui-user-profile-menu>
        </eui-header-user-profile>
      </eui-header>
    </eui-app-header>
    @if (user?.isActive) {
      <eui-app-toolbar>
        <eui-toolbar>
          <eui-toolbar-mega-menu
            [items]="sidebarItems"
            [attr.data-cy]="'main-menu'"
          ></eui-toolbar-mega-menu>
        </eui-toolbar>
      </eui-app-toolbar>
    }
  </eui-app>
}
